export const enum InputBoxTextAlign {
    LEFT = "left",
    CENTER = "center",
    RIGHT = "right",
}
